import { getCookie } from 'cookies-next'

// facebook cookie
export function getFbcCookie() {
  return getCookie('_fbc')
}
export function getFbpCookie() {
  return getCookie('_fbp')
}
